// extracted by mini-css-extract-plugin
module.exports = {"header__container":"core_header__container__3JANy","header__title":"core_header__title__Zujsz","breadcrumbs":"core_breadcrumbs__3L4CW"};